<template>
  <div :class="['panel-group', `el-size--${size}`, css]">
    
    <!-- lll = {{children.length}} -->
    <div      
      v-for="(panel, index) in children"
      :key="panel.title"
      :id="panel.title"
      :panel-index="index"
      :class="['panel-group--panel', isOpen(index) ? 'open' : '', panelHasTitle(panel) ? '':'pnlHidden']"
      :style="
        `max-height: ${
          isOpen(index) && panelHeights[index]
            ? panelHeights[index].open + 'px' : panelHeights[index]
            ? panelHeights[index].closed + 'px' : closedPanelHeight
        }`
      "
    >
      <!-- <span
        @click="togglePanel(index)"
        :class="['minmax', isOpen(index) ? 'min' : 'max']"
      ></span> -->

    <!--
      <i
        @click="togglePanel(index)"
        class="toggler fal fa-chevron-down text--m"
        :class="[isOpen(index) ? 'open' : '']"
      ></i>
    <i class="fal fa-plus"></i>
      -->

      <i
        @click="togglePanel(index)"
        class="toggler text--m"
        :class="[isOpen(index) ? 'open' : '',isOpen(index) ? 'fal fa-minus' : 'fal fa-plus' ]"
      ></i>
      <h3 @click="togglePanel(index)" v-text="panel.title" class="pl-m"></h3>
      <component
        :is="panel.type"
        v-bind="panel"
        embedded
        exclude-title
        :ref="`panel-comp-${index}`"
        @content-loaded="setPanelHeights"
        :class="[
          'py-2xl',
          'pl-m',
          'panel-content',
          `panel-content--${panel.type}`
        ]"
      ></component>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import PublicationList from "@/components/PublicationList.vue";
// import Content from "@/components/Content.vue";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: "large"
    },
    resizeTrig: {
      type: Number,
      default: -1
    },
    properties: {
      type: Object,
      default: null
    },
    css: String
  },
  data() {
    return {
      // openPanels: [],
      panelHeights: []
    };
  },
  watch: {
    resizeTrig() {
      this.setPanelHeights();
    }
  },
  // components: {
  //   PublicationList
  // },
  methods: {
    panelHasTitle(panel)
    {
        if(panel.title==undefined)
        {
            return false;
        }
        return true;        
    },
    togglePanel(index) {
      let _panels = _.clone(this.openPanels);
      let _i = _panels.indexOf(index);

      if (_i > -1) {
        _panels.splice(_i, 1);
      } else {
        _panels.push(index);
      }
      this.$set(this, "openPanels", _panels);
    },
    isOpen(index) {
      return this.openPanels.indexOf(index) > -1;
    },
    setPanelHeights: _.debounce(function(e) {
      // console.log(
      //   "MAYBE CONTENT LOADED SET PANEL HEIGHTS!!!!",
      //   " :: ",
      //   this.$refs
      // );
      let halfScreenHeight = window.innerHeight / 2;
      this.panelHeights = _.map(this.$refs, function(ref) {
        let el = ref.$el || ref[0].$el,
          ttl = el.previousElementSibling,
          buffer = 120;
        // console.log("el", el)
        return {
          open: el
            ? Math.max(halfScreenHeight, el.offsetHeight + buffer)
            : null,
          closed: ttl ? ttl.offsetHeight + 40 : null
        };
      });
    }, 600)
  },
  computed: {
    ...mapState(["search", "dimensions"]),
    openPanels: {
      get() {
        return this.$store.state.openPanels;
      },
      set(value) {
        this.$store.commit("UPDATE_PANELS", value);
      }
    },
    isSearchable() {
      return this.properties && this.properties.isSearchable;
    },
    closedPanelHeight() {
      return this.size === "large"
        ? "13vh"
        : this.size === "medium"
        ? "9vh"
        : "7vmax";
    }
  },
  mounted() {
    if (this.isSearchable) {
      this.$watch("search", function() {
        console.log("search >> ", this.search);
      });
    }

    let imgs = document.querySelectorAll("img");
    // console.log("IMGS > ", imgs);
    this.$set(this, "openPanels", []);
    setTimeout(
      function() {
        this.setPanelHeights();
        // OPEN FIRST ITEM AS DEFAULT <<
        this.togglePanel(0);
      }.bind(this),
      500
    );
  }
};
</script>

<style lang="stylus">
.pnlHidden
  display none !important
.panel-group
  +below(815px)
    &:not(:first-child)
      padding-top 4vmax
  &--panel
    _flex(row, wrap, center, flex-end)
    border-bottom 1px solid gray_2
    // max-height 13vh
    overflow hidden
    position relative
    transform-style preserve-3d
    will-change max-height
    transition max-height 0.6s ease-out-cubic
    padding-top 20px
    // /.el-size--large &
    //   pad('2xl',top)
    // /.el-size--medium &
    //   pad('xl',top)
    // /.el-size--small &:not(:first-child)
    //   pad('l',top)
    // +below(560px)
    //   &:not(:first-child)
    //     padding-top 2vh !important
    i
      color c_primary
    h3
      color c_primary
      cursor pointer
      font-weight 200
      // transform translateY(-8%)
      +below(42em, orientation: portrait)
        transform none
    & > *
      flex 0 0 97%
      +below(840px)
        flex 0 0 96%
      +below(600px)
        flex 0 0 94%

    .content-block--text
      pad('xl', right)
      li
        pad('l', bottom)
        strong
          display block
          pad('xs',bottom)
    .toggler
      cursor pointer
      flex 0 0 3%
      width 2vmin
      // height @width
      position relative
      display block
      transform-origin center center
      transform-style preserve-3d
      will-change transform
      transition transform 0.4s ease-out-cubic
    .panel-content
      transform-style preserve-3d
      will-change padding
      transition padding 0.6s ease-out-cubic
      overflow hidden
    &.open
      max-height 68vh
      .panel-content
        pad('xl',top)
      .toggler
        //transform rotate3d(1, 0, 0, 180deg)
        // &:before
        //   transform translate(-50%,-50%) rotate(-180deg)
</style>
